<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de Marcas</h1>
    <div class="results" v-if="brands">
      <div class="results__element" v-for="(brand, index) in brands" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="brand.name"></h2>
        </div>
        <div class="results__actions">
          <button @click.prevent="$parent.$emit('view', brand.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Marca</button>
          <button @click.prevent="$parent.$emit('edit', brand.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Marca</button>
          <button @click.prevent="deleteBrand(brand.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Pagina</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      brandId: null,
      brands: null,
      confirm: false
    }
  },
  created: function () {
    this.getBrands()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getBrands()
    },
    '$store.state.elementChanged': function () {
      this.getBrands()
    }
  },
  methods: {
    getBrands: function () {
			this.brands = null
      let httpRequest = {
        params: '?' + this.filters,
        module: 'brands'
      }
      this.get(httpRequest)
        .then(
          brands => {
            this.brands = brands.data
          }
        ).catch(
          () => {
            this.brands = null
          }
        )
    },
    deleteBrand: function (id) {
      this.confirm = true
      this.brandId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'brands'
      }
      this.delete(this.brandId, httpRequest)
        .then(
          response => {
						this.$store.commit('elementChanged', {
							module: 'brandDelete',
              time: Math.round(new Date().getTime() / 1000)
						})
            this.$store.commit('notificate', {
              title: 'MARCA BORRADA',
              text: 'La marca ha sido borrada correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'MARCA NO BORRADA',
              text: 'No se pudo borrar la marca seleccionada, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/designers/list.vue